export default __webpack_public_path__ + "static/media/pandas.7c64eb39.svg";